import React, { useEffect, useRef, useState } from "react";
import RecommendationIcon from "../icons/recommendation-icon.svg";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import AngleDownIcon from "../icons/angle-down.svg";
import { Button } from "../../common";

interface RecommendationTypeSelectProps {
  label: string;
  placeholder: string;
  value: string;
  onChange: (val: string) => void;
  errors: any;
  register: any;
  customClass?: string;
  candidateName: string;
  errorMessage?: string;
}
const RecommendationType = ({
  label,
  placeholder,
  value,
  onChange,
  customClass,
  candidateName,
  errorMessage,
}: RecommendationTypeSelectProps) => {
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const [selectedValue, setSelectedValue] = useState(value);

  const toggleDropdown = () => {
    setDropDownOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setDropDownOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div className={`select-wrapper ${customClass}`} ref={wrapperRef}>
      <div className="form-group">
        <label className="form-label">{label}</label>
        <div>
          <div className="field-wrapper" onClick={toggleDropdown}>
            <div className="search-icon">
              <img src={RecommendationIcon} alt="icon" />
            </div>
            <input
              type="text"
              className="form-control"
              placeholder={placeholder}
              // onFocus={toggleDropdown}
              value={value}
              readOnly
            />
            <div className="select-icon-down">
              <img src={AngleDownIcon} alt="icon" />
            </div>
          </div>
          {errorMessage && (
            <span className="error-msg" style={{ color: "red", display: "block", marginTop: 4 }}>
              {errorMessage}
            </span>
          )}
        </div>
      </div>

      {dropDownOpen && (
        <div className="dropdown-wrapper">
          <div className="radio-wrapper">
            <RadioGroup
              value={value}
              onChange={(e) => {
                setSelectedValue(e.target.value);
                onChange(e.target.value);
              }}
              className="radio-group"
            >
              <FormControlLabel
                value={`${candidateName} and I are colleagues.`}
                control={<Radio size="small" />}
                label={`${candidateName} and I are colleagues.`}
              />
              <FormControlLabel
                value={`I report to ${candidateName}.`}
                control={<Radio size="small" />}
                label={`I report to ${candidateName}.`}
              />
              <FormControlLabel
                value={`${candidateName} reports to me.`}
                control={<Radio size="small" />}
                label={`${candidateName} reports to me.`}
              />
              <FormControlLabel
                value={`I am ${candidateName}'s client.`}
                control={<Radio size="small" />}
                label={`I am ${candidateName}'s client.`}
              />
              <FormControlLabel
                value={`${candidateName} was my client.`}
                control={<Radio size="small" />}
                label={`${candidateName} was my client.`}
              />
            </RadioGroup>

            <div className="form-group">
              <label>Other (Please specify)</label>
              <textarea
                name="other"
                placeholder="Please enter your recommendation type..."
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                  setSelectedValue(e.target.value);
                }}
              ></textarea>
            </div>
            <div className="btn-wrapper">
              <Button
                type="button"
                color="primary"
                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                  onChange(selectedValue);
                  toggleDropdown();
                }}
              >
                Done
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecommendationType;
